<p-badge
  [severity]="getBadgeSeverity()"
  [value]="showValue() || count() !== null ? getBadgeValue() : ''"
  class="uppercase"
/>
